type Politeness = 'polite' | 'assertive'

const POLITE_REGION_ID = 'live-region-polite'
const ASSERTIVE_REGION_ID = 'live-region-assertive'

const pendingTimers: Record<string, ReturnType<typeof setTimeout> | null> = {
  [POLITE_REGION_ID]: null,
  [ASSERTIVE_REGION_ID]: null,
}

export function useAnnouncer() {
  const announce = (message: string, politeness: Politeness = 'polite'): (() => void) => {
    if (typeof document === 'undefined') return () => {}

    const regionId = politeness === 'polite' ? POLITE_REGION_ID : ASSERTIVE_REGION_ID
    const region = document.getElementById(regionId)
    if (!region) return () => {}

    // Cancel any pending write for the same region so messages don't stomp each other.
    const existing = pendingTimers[regionId]
    if (existing) {
      clearTimeout(existing)
    }

    region.textContent = ''

    // Delay before writing so identical consecutive messages still trigger an
    // announcement, and so the screen reader picks up the change.
    const timer = setTimeout(() => {
      region.textContent = message
      pendingTimers[regionId] = null
    }, 50)
    pendingTimers[regionId] = timer

    return () => {
      if (pendingTimers[regionId] === timer) {
        clearTimeout(timer)
        pendingTimers[regionId] = null
      }
    }
  }

  return { announce }
}
